import request from '@/utils/request'

// 获取字典树（默认返回三层：空间类型 -> 家电类别 -> 具体产品）
export function getDictionaryTree(params) {
  return request({
    url: '/dictionary/tree',
    method: 'get',
    params
  })
}

// 按层级懒加载：空间类型列表
export function getApplianceRooms(params) {
  return request({
    url: '/dictionary/appliance-rooms',
    method: 'get',
    params
  })
}

// 按层级懒加载：家电类别（按空间类型）
export function getApplianceBundle(params) {
  return request({
    url: '/dictionary/appliance-bundle',
    method: 'get',
    params
  })
}

// 按层级懒加载：产品（按家电类别，支持分页）
export function getApplianceProducts(params) {
  return request({
    url: '/dictionary/appliance-products',
    method: 'get',
    params
  })
}

// 新增字典节点
export function createDictionary(data) {
  return request({
    url: '/dictionary/create',
    method: 'post',
    data
  })
}

// 更新字典节点
export function updateDictionary(id, data) {
  return request({
    url: `/dictionary/update/${id}`,
    method: 'put',
    data
  })
}

// 删除字典节点
export function deleteDictionary(id) {
  return request({
    url: `/dictionary/delete/${id}`,
    method: 'delete'
  })
}

// 初始化种子数据
export function seedDictionary(data) {
  return request({
    url: '/dictionary/seed',
    method: 'post',
    data
  })
}

// Excel：导出（针对 getTree 数据结构）
export function exportDictionaryTreeExcel(params) {
  return request({
    url: '/dictionary/export-excel',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// Excel：下载导入模板
export function exportDictionaryTreeExcelTemplate() {
  return request({
    url: '/dictionary/export-excel-template',
    method: 'get',
    responseType: 'blob'
  })
}

// Excel：导入（multipart/form-data，字段名 file）
export function importDictionaryTreeExcel(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/dictionary/import-excel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 规格接口
export function getSpecifications(params) {
  return request({
    url: '/dictionary/specs-meta',
    method: 'get',
    params
  })
}
